/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmDialogService, UiKitModule } from '@serviceplan/ui-kit';
import { ClientCoreModule, StorageUtilityLib, USER_SESSION_TOKEN, UserSession } from '@thehubz/client/core';
import { CreateAssetDto } from '@thehubz/client/data-access-api';
import { AssetAnnotatorService } from '../../services/asset-annotator.service';

@Component({
  selector: 'thehubz-annotation-comments',
  templateUrl: './annotation-comments.component.html',
  styleUrls: ['./annotation-comments.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatTooltipModule, UiKitModule, ClientCoreModule],
})
export class AnnotationCommentsComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() annotations: any[] = [];
  @Input() assetType = '';
  @Input() readOnly = false;
  @Input() externalFlag = false;
  @Input() annotationDrawn = false;

  annotationCount = 0;
  currentUser?: UserSession;
  avatarSize = 50;
  newComment = '';
  isReplying = false;
  isEditReply = false;
  isDeleteReply = false;
  assetTypes = CreateAssetDto.AssetTypeEnum;
  isSupported = true;

  @Output() timestampClick = new EventEmitter<number>();
  @Output() pageClick = new EventEmitter<number>();
  @Output() toggleClick = new EventEmitter<{ annotation: any; index: number }>();
  @Output() editClick = new EventEmitter<{ annotation: any; index: number }>();
  @Output() deleteClick = new EventEmitter<{ annotation: any; index: number }>();
  @Output() replyClick = new EventEmitter<{ annotation: any; index: number }>();
  @Output() editReplyClick = new EventEmitter<{ annotationIndex: number; reply: any; index: number }>();
  @Output() deleteReplyClick = new EventEmitter<{ annotationIndex: number; index: number }>();
  @Output() replyToReplyClick = new EventEmitter<{ annotationIndex: number }>();
  @Output() saveAnnotationsClick = new EventEmitter<any>();

  @ViewChild('comments', { static: false }) comments?: ElementRef;

  constructor(
    @Inject(USER_SESSION_TOKEN) private userSessionToken: string,
    private storageUtility: StorageUtilityLib,
    private assetAnnotatorService: AssetAnnotatorService,
    private confirmDialog: ConfirmDialogService,
  ) {}

  ngOnInit(): void {
    this.currentUser = this.storageUtility.getLocalStorage<UserSession>(this.userSessionToken);
  }

  ngAfterViewInit() {
    if (window.innerWidth <= 1440) {
      this.avatarSize = 40;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['annotations']) {
      this.annotationCount = this.annotations.filter((ele: any) => ele.className !== 'Transformer' && ele.attrs.comment).length;
      this.scrollToBottom();
    }
    if (changes['assetType']) {
      this.isSupported = this.assetAnnotatorService.isSupportedForAnnotation(this.assetType);
    }
  }

  annotationTimeClick(timestamp: number) {
    this.timestampClick.emit(timestamp);
  }

  annotationPageClick(pageNum: number) {
    if (pageNum) {
      this.pageClick.emit(pageNum);
    }
  }

  toggleAnnotation(annotation: any, index: number) {
    console.log(annotation);
    this.toggleClick.emit({ annotation: annotation, index: index });
  }

  editAnnotation(annotation: any, index: number) {
    this.newComment = annotation.attrs.comment;
    this.editClick.emit({ annotation: annotation, index: index });
  }

  deleteAnnotation(annotation: any, index: number) {
    this.confirmDialog
      .open({
        title: $localize`Delete annotation`,
        message: $localize`Are you sure you want to delete this annotation?`,
      })
      .subscribe((confirmDelete: boolean) => {
        if (confirmDelete) {
          this.deleteClick.emit({ annotation: annotation, index: index });
        }
      });
  }

  replyToAnnotation(annotation: any, index: number) {
    this.newComment = '';
    this.isReplying = true;
    this.replyClick.emit({ annotation: annotation, index: index });
  }

  editReply(annotationIndex: number, reply: any, index: number) {
    this.newComment = reply.comment;
    this.isReplying = true;
    this.isEditReply = true;
    this.editReplyClick.emit({ annotationIndex: annotationIndex, reply: reply, index: index });
  }

  deleteReply(annotationIndex: number, index: number) {
    this.confirmDialog
      .open({
        title: $localize`Delete reply`,
        message: $localize`Are you sure you want to delete this reply?`,
      })
      .subscribe((confirm) => {
        if (confirm) {
          this.isReplying = true;
          this.isDeleteReply = true;
          this.deleteReplyClick.emit({ annotationIndex: annotationIndex, index: index });
        }
      });
  }

  replyToReply(annotationIndex: number) {
    this.isReplying = true;
    this.newComment = '';
    this.replyToReplyClick.emit({ annotationIndex: annotationIndex });
  }

  scrollToBottom(): void {
    try {
      // Scroll to the bottom of the container
      if (typeof this.comments === 'undefined') {
        return;
      }
      this.comments.nativeElement.scrollTop = this.comments?.nativeElement.scrollHeight;
    } catch (err) {
      console.error(err);
    }
  }

  saveAnnotations() {
    this.saveAnnotationsClick.emit({
      comment: this.newComment,
      isReply: this.isReplying,
      isReplyEdit: this.isEditReply,
      isReplyDelete: this.isDeleteReply,
    });
  }
}
